// Auto-generated normalizer for table: Observaciones
export function observacionesNormalize(row) {
  return {
    idObservacion: row.idObservacion ?? row.IdObservacion ?? row['IdObservacion'] ?? 0,
    idPersona: row.idPersona ?? row.IdPersona ?? row['IdPersona'] ?? 0,
    nota: row.nota ?? row.Nota ?? row['Nota'] ?? '',
    fechaRegistro: row.fechaRegistro ?? row.FechaRegistro ?? row['FechaRegistro'] ?? null,
    registradoPor: row.registradoPor ?? row.RegistradoPor ?? row['RegistradoPor'] ?? '',
    tipo: row.tipo ?? row.Tipo ?? row['Tipo'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
